export enum HeroVariants {
  Blog = 'Blog',
  FullBleed = 'Full Bleed',
  Base = 'Base',
  Pillar = 'Pillar',
}

export enum HeroTextSize {
  Default = 'Default',
  Large = 'Large',
}

export enum HeroBlogImageSize {
  Wide = 'Wide Image',
  FourThree = '4:3 Image',
}
